module.exports = __webpack_public_path__ + "img/board-bg-light-brown.217babb9.png";